import Ajax from "Utils/ajax";
export const getBluebookList = (data) => Ajax.post('hr/getBluebookList',data);
export const getBluebookDetails = (data) => Ajax.post('hr/getBluebookDetails',data);